module.exports = __webpack_public_path__ + "img/playster.e923aa93.png";